import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function BreaksHeader({ dataType, sortConfig, requestSort }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 pe-2 item-type-bar-header rounded-2 fs-8-xs table-header user-select-none">
                <div style={{ width: 56 }}></div>
                <Col>
                    <Row>
                        <Col xs lg={3} onClick={() => requestSort("start_datetime")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center justify-content-lg-start">
                                <span className="text-center">Start</span>
                                <span className="col-1">{renderSortIcon("start_datetime", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col xs={3} lg={1} onClick={() => requestSort("duration")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1">Duration</span>
                                <span className="col-1">{renderSortIcon("duration", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col xs={3} lg={1} onClick={() => requestSort(dataType === 1 ? "score" : "delta")} className="align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1">{dataType === 1 ? "Score" : "Delta"}</span>
                                <span className="col-1">{renderSortIcon(dataType === 1 ? "score" : "delta", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col className="d-none d-lg-block">Content Groups</Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}
